
export default {install (Vue) 
{
    const CriterioDominios = 
    {
        ObtenerDominioAgrupadorCriterio (axios,pDominioAgrupador,pCriterio) {
            var itemCriterios = [];
            axios.get(`consultas/criterios?entero=${pDominioAgrupador}&cadena=${pCriterio}`)
            .then(r => {
              for(let id in r.data) 
              {
                let dominio = {
                  dominio_id: r.data[id].dominio_id,
                  descripcion: r.data[id].descripcion,
                }
                itemCriterios.push(dominio);
              }
            });
            return itemCriterios;
        },
        ObtenerDominioAgrupadorCriterioPromise (axios,pDominioAgrupador,pCriterio) {
          return new Promise ((resolve,reject)=>{
              var itemCriterios = [];
              axios.get(`consultas/criterios?entero=${pDominioAgrupador}&cadena=${pCriterio}`).then(r=>{
              for(let id in r.data) 
              {
                let dominio = {
                  dominio_id: r.data[id].dominio_id,
                  descripcion: r.data[id].descripcion,
                }
                itemCriterios.push(dominio);
              }
              resolve(itemCriterios);
            })
        })
      }
    }
    Vue.prototype.$criterios_dominios = CriterioDominios;    
}}